import { Header, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import { useChallenges } from '../../../store/challenge.context';
import { useToolPanel } from '../../../store/tool-panel.context';
import { ChallengeDescriptor } from '../../../types/Challenge';
import { Event } from '../../../types/Event';
import ChallengeCard from './ChallengeCard';
import GeneralBackupChallenges from './GeneralBackupChallenges';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { useTranslation } from 'react-i18next';

interface BackupChallengesProps {
  target: Event;
}

const BackupChallenges: React.FC<BackupChallengesProps> = ({ target }) => {
  const { t } = useTranslation();
  const { selectedChallengesById } = useChallenges();
  const { toggleChallengeInfo } = useToolPanel();

  return (
    <SpaceBetween direction="vertical" size="s">
      <GeneralBackupChallenges target={target} />
      <Header variant="h2">{t(i18nKeys.newEvent.headers.specificChallengeBackupChallenges)}</Header>
      {target.challengeDescriptors.map((cd: ChallengeDescriptor, i) => {
        if (cd.challengeId) {
          const challengeListItem = selectedChallengesById?.find(ch => ch.challengeId === cd.challengeId);
          if (challengeListItem) {
            return (
              <ChallengeCard
                key={`challenge-card-${i}`}
                toggleChallengeInfo={toggleChallengeInfo}
                index={i}
                target={target}
                challenge={challengeListItem}
                challengeDescriptor={cd}
                backupChallenges
              />
            );
          }
        }
      })}
    </SpaceBetween>
  );
};
export default BackupChallenges;
